// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"0be90cf8","768":"fc85ece2"}[chunkId] + ".chunk.css";
};